import { StyleSheet, Text, View } from "react-native";

import { central } from "../theme/tokens";

type MonarchBrandLockupProps = {
  muted?: boolean;
  inverse?: boolean;
  size?: "auth" | "sidebar" | "mobile" | "public";
};

export function MonarchBrandLockup({
  muted = false,
  inverse = true,
  size = "sidebar",
}: MonarchBrandLockupProps) {
  const mobile = size === "mobile";
  const auth = size === "auth";
  const publicSize = size === "public";

  return (
    <View
      accessible
      accessibilityLabel="Monarch Funeral Home and Cremation Services"
      style={[
        styles.lockup,
        auth ? styles.lockupAuth : null,
        publicSize ? styles.lockupPublic : null,
        mobile ? styles.lockupMobile : null,
        muted ? styles.muted : null,
      ]}
    >
      <Text
        numberOfLines={1}
        style={[
          styles.wordmark,
          !inverse ? { color: central.action.primary } : null,
          auth ? styles.wordmarkAuth : null,
          publicSize ? styles.wordmarkPublic : null,
          mobile ? styles.wordmarkMobile : null,
        ]}
      >
        Monarch
      </Text>
      {mobile ? null : (
        <>
          <View
            style={[
              styles.divider,
              !inverse ? { backgroundColor: central.border.strong } : null,
              auth ? styles.dividerAuth : null,
              publicSize ? styles.dividerPublic : null,
            ]}
          />
          <Text
            numberOfLines={2}
            style={[
              styles.descriptor,
              !inverse ? { color: central.text.secondary } : null,
              auth ? styles.descriptorAuth : null,
              publicSize ? styles.descriptorPublic : null,
            ]}
          >
            Funeral Home &amp; Cremation Services
          </Text>
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  lockup: {
    alignItems: "center",
    flexDirection: "row",
    maxWidth: "100%",
    minWidth: 0,
  },
  lockupAuth: {
    alignSelf: "center",
  },
  lockupPublic: {
    flexShrink: 1,
  },
  lockupMobile: {
    flexShrink: 1,
  },
  muted: {
    opacity: 0.7,
  },
  wordmark: {
    color: central.text.inverse,
    flexShrink: 0,
    fontFamily: "Newsreader_600SemiBold",
    fontSize: 26,
    letterSpacing: -0.25,
    lineHeight: 32,
  },
  wordmarkAuth: {
    fontSize: 42,
    letterSpacing: -0.45,
    lineHeight: 50,
  },
  wordmarkPublic: {
    fontSize: 30,
    lineHeight: 36,
  },
  wordmarkMobile: {
    fontSize: 22,
    lineHeight: 27,
  },
  divider: {
    alignSelf: "stretch",
    backgroundColor: "rgba(220,230,242,0.48)",
    marginHorizontal: 10,
    width: 1,
  },
  dividerAuth: {
    marginHorizontal: 10,
  },
  dividerPublic: {
    marginHorizontal: 12,
  },
  descriptor: {
    color: central.text.inverseMuted,
    flexShrink: 1,
    fontFamily: central.typography.bodyMedium,
    fontSize: 9,
    lineHeight: 13,
    maxWidth: 96,
  },
  descriptorAuth: {
    fontSize: 14,
    lineHeight: 20,
    maxWidth: 265,
  },
  descriptorPublic: {
    fontSize: 12,
    lineHeight: 17,
    maxWidth: 220,
  },
});
